import React, { useCallback, useEffect, useState } from "react";
import CardTables from "../atoms/CardTables";
import CreateAnuncio from "../organisms/Anuncios/CreateAnuncio";
import TableAnuncios from "../organisms/Anuncios/TableAnuncios";
import { GET_ANNOUNCEMENTS } from "../../api/apiAnuncios";
import { useSession } from "../../context/SessionContext";
import CardHeader from "../atoms/CardHeader";
import Breadcrumb from "../molecules/Breadcrumb";

const AnunciosTemplate = () => {
    const [anuncios, setAnuncios] = useState();
    const [loading, setLoading] = useState(false);
    const { user } = useSession();

    const getAnnouncements = useCallback ( async () => {
        try {
            setLoading(true);
            const dataAnnouncements = await GET_ANNOUNCEMENTS();

            let anunciosFiltrados = [];

            if (user?.role === "Accountant") {
                anunciosFiltrados = dataAnnouncements.filter(
                    a => a.type === "General" || a.type === "Accountant"
                );
            } else if (user?.role === "Lawyer") {
                anunciosFiltrados = dataAnnouncements.filter(
                    a => a.type === "General" || a.type === "Lawyer"
                );
            } else if (user?.role === "Admin" || user?.role === "HumanResources") {
                anunciosFiltrados = dataAnnouncements;
            } else {
                anunciosFiltrados = dataAnnouncements.filter(a => a.type === "General");
            }

            setAnuncios(anunciosFiltrados);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }, [user]);

    useEffect(() => {
        getAnnouncements();
    }, [getAnnouncements]);

    return(
        <div className="h-full w-full flex flex-col space-y-2">
            <CardHeader>
                <Breadcrumb
                    items={[
                        { label: "Avisos y blog", to: "/avisosyblog" },
                        { label: "Avisos", to: null },
                    ]}
                />
                {user?.roleInfo?.isSuperAdmin === true || user?.role === "HumanResources" ?
                        <CreateAnuncio refetch={getAnnouncements}/>
                    :
                        <div></div>
                }
            </CardHeader>
            <CardTables>
                <TableAnuncios data={anuncios} refetch={getAnnouncements} loading={loading} />
            </CardTables>
        </div>
    );
};

export default AnunciosTemplate;